import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationDischarge7MasterReferenceData = createAsyncThunk(
  'stop/getVerificationDischarge7MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationDischarge7MasterReferenceSlice = createSlice({
  name: 'stop/verificationDischarge7MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationDischarge7MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationDischarge7MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationDischarge7MasterReference } =
  verificationDischarge7MasterReferenceSlice.actions;

export default verificationDischarge7MasterReferenceSlice.reducer;
